<template>
  <v-container v-if="auditPeriods">
    <v-app-bar app dark dense color="secondary">
      <v-app-bar-title>{{ $t("auditor.years.title") }}</v-app-bar-title>
    </v-app-bar>

    <v-card>
      <v-simple-table>
        <template #default>
          <thead>
            <tr>
              <th>{{ $t("auditor.auditPeriods.year") }}</th>
              <th>{{ $t("auditor.auditPeriods.users") }}</th>
              <th width="1%"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="[year, auditPeriods] in groupedAuditPeriods" :key="year">
              <td>
                {{ year }}
              </td>

              <td>
                {{ auditPeriods.length }}
              </td>

              <td width="1%">
                <v-btn :to="{ name: 'auditYear', params: { year } }" color="secondary" icon exact>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import { prop, groupBy, toPairs, reverse } from "ramda";
import AuditPeriodsQuery from "@/gql/queries/auditor/AuditPeriodsQuery.gql";

export default {
  data() {
    return {
      auditPeriods: null,
    };
  },

  apollo: {
    auditPeriods: {
      query: AuditPeriodsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  computed: {
    groupedAuditPeriods() {
      return reverse(toPairs(groupBy(prop("year"), this.auditPeriods)));
    },
  },
};
</script>
